import styled from "styled-components";
import {colors, fonts, pxToCssFont} from "@vfit/shared/themes";

export const ListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const ListElement = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const CheckMark = styled.div`
  width: 18px;
  height: 30px;
`;

export const CircleSmall = styled.div`
  display: flex;
  border: none;
  flex-shrink: 0;
  padding: 0;
  margin: 0 0 0 16px !important;
  cursor: pointer;
  outline: inherit;
  background: ${colors.$e60000};
  border-radius: 100px;
  color: white;
  width: 26px;
  height: 26px;
  text-align: center;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${colors.$bd0000};
  }

  &:active {
    background: ${colors.$a10000};
  }
`;

export const OptionText = styled.div`
  flex: 1 0 0;
  p{
    margin:0
  }
  font-family: ${fonts.vodafone};
  ${pxToCssFont(20, 28)}
`;
